export default __webpack_public_path__ + "static/media/No.9-0.4a14f646.jpg";